import CtaLink from './cta-link'
import { useTranslations } from '@/utils/locale'
import { SizeType } from './cta-link'
import { usePage } from '@inertiajs/react'
import { getAltPath } from '@/utils/strings'

export default function DownloadPdfButton({
  buttonStyle,
  btnText,
  className,
  size = 'Base',
  overideDarkMode = false,
}: {
  buttonStyle: string
  btnText: string
  className?: string
  size?: SizeType
  overideDarkMode?: boolean
}) {
  const { t } = useTranslations()

  const { url } = usePage()

  const pdfPath = getAltPath(url, '.pdf')

  return (
    <a href={pdfPath} target="_blank">
      <CtaLink asButton className={className} style={buttonStyle} size={size} overideDarkMode={overideDarkMode}>
        <span className="font-bwi mr-2">&#xe94e;</span>
        {t(btnText)}
      </CtaLink>
    </a>
  )
}
